import React, {ElementType, FC, useMemo} from 'react';

import {cn} from '@bem-react/classname';
import {colorText, text} from '@gravity-ui/uikit';

import {MarkdownTextProps} from './MarkdownText.types';
import {markdownToHTML} from './MarkdownText.utils';

import './MarkdownText.scss';

const cnMarkdownText = cn('MarkdownText');

const MarkdownText: FC<MarkdownTextProps> = ({text: markdown, className, color, as, ...props}) => {
    const html = useMemo(() => markdownToHTML(markdown), [markdown]);
    const Tag: ElementType = as || 'div';

    return (
        <Tag
            {...props}
            className={colorText({color}, text(props, cnMarkdownText('', [className])))}
            dangerouslySetInnerHTML={{__html: html}}
        />
    );
};
export default MarkdownText;
